import React from 'react';
import { useIsDarkMode, useChartPaletteId, seriesColor } from './chartTheme';
import '../ReportsNative.css';

/**
 * Compact legend strip rendered above charts (per mocks .chart-legend),
 * replacing the default Recharts <Legend/>.
 *
 * Props: series [{ key, label, color? }]
 */
export function ChartLegend({ series = [], style }) {
  const dark = useIsDarkMode();
  useChartPaletteId(); // swatches follow a palette switch
  if (series.length < 2) return null;
  return (
    <div className="rn-chart-legend" style={style}>
      {series.map((s, i) => (
        <span key={s.key ?? i}>
          <i style={{ background: seriesColor(s, i, dark) }} />
          {s.label ?? s.key}
        </span>
      ))}
    </div>
  );
}

export default ChartLegend;
